import Icon from "@hudson/ui/components/Icon";
import classNames from "classnames";
import Location from "./Location";

export default function ({
  hideString,
  horizontal,
  shiftLeft,
  stops,
}: {
  hideString?: boolean;
  horizontal?: boolean;
  shiftLeft?: boolean;
  stops: be.Stop[];
}) {
  return (
    <>
      {stops
        .filter((stop) => stop.location?.code)
        .map((stop, index) => (
          <>
            <Location
              location={stop.location}
              shiftLeft={shiftLeft}
              small={true}
              horizontal={horizontal}
              hideString={hideString}
              key={index}
            />

            <Icon
              type={horizontal ? "arrowRight" : "arrowDown"}
              className={classNames(
                shiftLeft ? "ml-5" : horizontal ? "ml-0" : "ml-3",
                index == stops.length - 1 ? "w-8 h-8" : "w-6 h-6",
              )}
              color="var(--primary-color-darker)"
            />
          </>
        ))}
    </>
  );
}
